__turbopack_context__.v({
  "playButton": "herovideo-module-scss-module__gnIJdG__playButton",
  "playButtonText": "herovideo-module-scss-module__gnIJdG__playButtonText",
  "videoPlayerButton": "herovideo-module-scss-module__gnIJdG__videoPlayerButton",
});
